import React, { useState, useContext } from 'react'

import StudentsIcon from '@BUP/assets/Images/Data/students_icon.svg'
import { useTranslation } from 'react-i18next'
import styles from './networks-components.module.scss'
import { friendshipNetworkSelected } from '@BUP/constants'
import SubtitleDashboard from '@BUP/components/Generics/SubtitleDashboard'
import SelectNetworkGroupButtons from '@BUP/components/Generics/NetworkGraph/SelectNetworkGroupButtons'
import SelectGraphButtons from '@BUP/components/Generics/NetworkGraph/SelectGraphButtons'
import IndicatorsNetworkInfo from '@BUP/components/Generics/NetworkGraph/IndicatorsNetworkInfo'
import GraphListGenderCard from '@BUP/components/Generics/Cards/GraphListGenderCard'
import NetworksGraphComponent from '../networksGraphComponent'
import { LocationContext } from '@BUP/contexts/LocationContext'

const NetworkComponent = ({ filterPreAnalyticData }) => {
  const locale = useContext(LocationContext)
  const language = locale.lenguage
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.dashBoardSociogram'
  })
  const [selectedIntensityQuestion, setSelectedIntensityQuestion] =
    useState(null)

  const [buttonState, setSelectNetworkButtonState] = useState(
    friendshipNetworkSelected
  )

  const networkCategoriesQuestions = {
    friendshipNetwork: language === 'ES' || language === 'PT' ? 37 : 57,
    onlineGames: language === 'ES' || language === 'PT' ? 47 : 67,
    socialMedia: language === 'ES' || language === 'PT' ? 50 : 70,
    noRelationNetwork: language === 'ES' || language === 'PT' ? 40 : 60,
    agressionOfPerception: selectedIntensityQuestion
  }
  const questionId = networkCategoriesQuestions[buttonState]

  const courseId = parseInt(filterPreAnalyticData.courseId, 10)
  const companions = filterPreAnalyticData.surveyId.companions

  const handleCourseDensity = (courseId, companions) => {
    return companions.filter(companion =>
      companion.courses.map(course => course.courseId).includes(courseId)
    )
  }

  const courseCompanions = handleCourseDensity(courseId, companions)

  return (
    <div className={styles.container}>
      <SubtitleDashboard
        icon={StudentsIcon}
        text={t('networkTitle')}
      />
      <SelectNetworkGroupButtons
        language={language}
        buttonState={buttonState}
        setSelectedIntensityQuestion={setSelectedIntensityQuestion}
        setSelectNetworkButtonState={setSelectNetworkButtonState}
      />
      <SelectGraphButtons
        language={language}
        buttonState={buttonState}
        setSelectedIntensityQuestion={setSelectedIntensityQuestion}
        selectedIntensityQuestion={selectedIntensityQuestion}
      />
      <div className={styles.information_container}>
        <IndicatorsNetworkInfo
          language={language}
          questionId={questionId}
          buttonState={buttonState}
          filterPreAnalyticData={filterPreAnalyticData}
          selectedIntensityQuestion={selectedIntensityQuestion}
          courseCompanions={courseCompanions}
        />
        <GraphListGenderCard buttonState={buttonState} />
      </div>
      <NetworksGraphComponent
        buttonState={buttonState}
        language={language}
        questionId={questionId}
        selectedIntensityQuestion={selectedIntensityQuestion}
        filterPreAnalyticData={filterPreAnalyticData}
      />
    </div>
  )
}

export default NetworkComponent
